module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/path.js
// module id = 10
// module chunks = 0 1